export default {
  acab: 'ACAB',
  actions: 'Ações',
  addProduct: 'Adicionar produto',
  arcPosition: 'Posição ARC',
  businessId: 'Id comercial',
  businessPhone: 'telefone comercial',
  cancel: 'Cancelar',
  client: 'Cliente',
  clientReference: 'Referência do Cliente',
  clients: 'Clientes',
  clientSuccessfullyCreated: 'Cliente criado com sucesso',
  clv: 'CLV',
  codeLab: 'Code Lab',
  colimptexCode: 'Código Colimptex',
  color: 'Cor',
  colors: 'Cores',
  colorSuccessfullyCreated: 'Cor criada com sucesso',
  colorSuccessfullyUpdated: 'Cor atualizada com sucesso',
  composition: 'Composição',
  contactPerson: 'Contato',
  container: 'Recipiente',
  containers: 'Recipientes',
  containerSuccessfullyCreated: 'Contêiner criado com sucesso',
  containerSuccessfullyUpdated: 'Container atualizado com sucesso',
  createClient: 'Criar cliente',
  createColor: 'Criar cores',
  createContainerType: 'Criar tipo de contêiner',
  createOrderDetail: 'Criar detalhes de ordem',
  createOrder: 'Criar ordem',
  createProduct: 'Criar produto',
  createPurchase: 'Criar compra',
  createPurchaseDetail: 'Criar detalhes de compra',
  createSeller: 'Criar vendedor',
  createSupplier: 'Criar fornecedor',
  created: 'criado com sucesso',
  crf: 'CRF',
  csf: 'CSF',
  currency: 'Moeda',
  deleteClient: 'Excluir cliente',
  deletePurchase: 'Excluir compra',
  doYouWantToDeleteThisClient: 'Deseja realmente excluir este cliente?',
  doYouWantToDeleteThisColor: 'Deseja mesmo apagar esta cor?',
  doYouWantToDeleteThisContainer: 'Deseja realmente excluir este contêiner?',
  doYouWantToDeleteThisProduct: 'Deseja realmente excluir este produto?',
  doYouWantToDeleteThisPurchase: 'Deseja realmente excluir esta compra?',
  doYouWantToDeleteThisSeller: 'Deseja realmente excluir este vendedor?',
  doYouWantToDeleteThisSupplier: 'Deseja realmente excluir este fornecedor?',
  editAddedProduct: 'Editar produto adicionado',
  editClient: 'Editar cliente',
  editColor: 'Editar cor',
  editContainer: 'Editar contêiner',
  editOrderDetail: 'Editar detalhes do pedido',
  editOrder: 'Ordem de edição',
  editProduct: 'Editar produto',
  editProvider: 'Editar provedor',
  editPurchase: 'Editar compra',
  editSeller: 'Editar vendedor',
  editSupplier: 'Editar fornecedor',
  email: 'Email',
  enterDescription: 'Digite uma descrição do usuário',
  factory: 'Fábrica',
  fca: 'FCA',
  fiber: 'Fibra',
  finalKilogramsQuantity: 'Quantidade final em quilogramas',
  finalMetersQuantity: 'Quantidade final em metros',
  finished: 'Acabada',
  hs: 'HS',
  iva: 'IVA',
  key: 'chave',
  kilogramsMaximumCapacity: 'Capacidade máxima em quilogramas',
  label: 'Rótulo',
  language: 'Língua',
  loading: 'Carregar...',
  metersKilogramsQuantity: 'm/kg quantidade',
  mt3: 'm3',
  mustChargeBeforeCreatingItems: 'Deve carregar antes de criar itens',
  name: 'Nome',
  newClient: 'Novo cliente',
  newColor: 'Nova cor',
  newContainer: 'Novo contêiner',
  newOrderDetail: 'Detalhes da nova ordem',
  newOrder: 'Nova ordem',
  newProduct: 'Novo produto',
  newProvider: 'Novo provedor',
  newPurchase: 'Nova compra',
  newSeller: 'Novo vendedor',
  newSupplier: 'Novo fornecedor',
  nit: 'Número de identificação',
  noElementsRegistered: 'Nenhum elemento registrado',
  onlyNumbersAllowed: 'Somente números permitidos',
  paint: 'Pintura',
  performance: 'Atuação',
  phone: 'Telefone',
  portOccupation: 'Ocupação Portuária',
  print: 'Impressão',
  productionDate: 'Data de produção',
  product: 'Produtos',
  products: 'Produtos',
  productSuccessfullyCreated: 'Produto criado com sucesso',
  productSuccessfullyUpdated: 'Produto atualizado com sucesso',
  profileImagePath: 'URL da imagem do perfil',
  psv: 'PSV',
  purchaseSuccessfullyCreated: 'Compra criada com sucesso',
  purchaseSuccessfullyUpdated: 'Compra atualizada com sucesso',
  pvp: 'PVP',
  referenceInChina: 'Referência na China',
  rgb: 'RGB',
  requiredAmount: 'Quantidade necessária',
  requirement: 'Requerimento',
  save: 'Salvar',
  search: 'Busca',
  seller: 'Vendedor',
  sellers: 'Vendedores',
  sellerSuccessfullyCreated: 'Vendedor criado com sucesso',
  sellerSuccessfullyUpdated: 'Vendedor atualizado com sucesso',
  shippingDate: 'Data de envio',
  shortName: 'Nome curto',
  sku: 'SKU',
  subInvoice: 'Subfatura',
  sublimation: 'Sublimação',
  supplier: 'Fornecedor',
  suppliers: 'Fornecedores',
  supplierSuccessfullyCreated: 'Fornecedor criado com sucesso',
  supplierSuccessfullyUpdated: 'Fornecedor atualizado com sucesso',
  taxesRefund: 'Restituição de impostos',
  totalAmount: 'Valor total',
  trm: 'TRM',
  typeOfContainer: 'Tipo de contêiner',
  updated: 'atualizado com sucesso',
  unitMeasure: 'Unidade de medida',
  viewClient: 'Exibir cliente',
  weight: 'Peso',
  wide: 'Largo',
  withholdingTax: 'Retenção na fonte'
}
